'use client';

import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { NO_TARIFFS_ERROR_CAUSE } from '@/constants';
import { ErrorPage } from '../components/error-page';
import { ContentBox } from '../components/form-box/form-box';
import { FormHead } from '../components/form-head/form-head';

const ErrorComponent = (props: { error: Error & { digest?: string }; reset: () => void }) => {
  if (props.error.cause === NO_TARIFFS_ERROR_CAUSE) {
    return (
      <>
        <FormHead>
          <Headline align="center" renderAs="h1">
            Tarife nicht verfügbar
          </Headline>
        </FormHead>
        <ContentBox>
          <Text renderAs="p">
            Leider können wir aktuell keine Tarife anbieten.
            <br />
            Bitte versuche es später noch einmal.
          </Text>
          <TextCTA as="a" href="/" slim>
            Zurück zur Homepage
          </TextCTA>
        </ContentBox>
      </>
    );
  }

  return <ErrorPage {...props} />;
};

export default ErrorComponent;
